import React from "react"
import * as svg from "svg"

export default function SVGIcon({ name, className, style }) {
  return React.createElement(svg[name], {
    className,
    style,
  })
}
